<template>
<a href="#">
  <div class="inspiration-card">
    <div class="inspiration-card__header">
      <div class="inspiration-card__img-container">
        <img class="inspiration-card__img" src="" alt="" loading="lazy">
      </div>
    </div>
    <div class="inspiration-card__body">
      <p class="inspiration-card__title">
        <slot />
      </p>
      <p class="inspiration-card__link">View <svg-arrow-long></svg-arrow-long></p>
    </div>
  </div>
</a>
</template>

<script>
export default {
  props: {
    payload: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {

    }
  },

  mounted() {
    //console.log('InspirationCard:', this.payload);
  }
}
</script>

